import { IAddress } from '../address/address.interface';

export interface ShippingSource {
  shippingSourceCode: string;
  shippingSourceDesc: string;
  shippingSourceId: number;
  suffixCode: string;
  address?: IAddress;
}
